module.exports = __webpack_public_path__ + "assets/254a7b6c88489c09cebbca8b88bc8dcd.png";